// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';
import SearchQualifiersRaceView from '@utmb/types/view/SearchQualifiersRaceView';
// Styles
import styles from './qualifiers-mobile.module.scss';
import { Link } from '@utmb/design-system/link/link';

const QualifiersMobileContent = (props: Partial<SearchQualifiersRaceView>): ReactElement => {
    const { distance, elevationGain, startPlace, uriResults, url } = props;

    const { t } = useTranslation();

    return (
        <>
            <div className={`row ${styles.root} ${styles.stats_container}`}>
                {startPlace && (
                    <div className="col-6">
                        <div className={styles.stat_mobile_wrapper}>
                            <Font.OxaniumBold mobile="14" className={`lh-20 ${styles.stat_label}`}>
                                {t('qualifier.place')}
                            </Font.OxaniumBold>

                            <Font.OxaniumBold mobile="14" className={`${styles.stat_name}`}>
                                <Icon variant={IconsEnum.PIN} />
                                {startPlace}
                            </Font.OxaniumBold>
                        </div>
                    </div>
                )}

                {distance && (
                    <div className="col-6">
                        <div className={styles.stat_mobile_wrapper}>
                            <Font.OxaniumBold mobile="14" className={`lh-20 ${styles.stat_label}`}>
                                {t('qualifier.distance.label')}
                            </Font.OxaniumBold>

                            <Font.OxaniumBold mobile="14" className={`${styles.stat_name}`}>
                                {distance}
                                {t('qualifier.distance.sufix')}
                            </Font.OxaniumBold>
                        </div>
                    </div>
                )}

                {elevationGain && (
                    <div className="col-6">
                        <div className={styles.stat_mobile_wrapper}>
                            <Font.OxaniumBold mobile="14" className={`lh-20 ${styles.stat_label}`}>
                                {t('qualifier.elevation.label')}
                            </Font.OxaniumBold>

                            <Font.OxaniumBold mobile="14" className={`${styles.stat_name}`}>
                                {elevationGain}
                                {t('qualifier.elevation.sufix')}
                            </Font.OxaniumBold>
                        </div>
                    </div>
                )}
            </div>
            <div className={`row ${styles.root} ${styles.buttons_container}`}>
                {url && (
                    <div className={`col-12 ${styles.button_container}`}>
                        <Link href={url} className={styles.button}>
                            <Icon variant={IconsEnum.RACE} />
                            <Font.FuturaHeavy mobile="14" className={styles.button_label}>
                                {t('qualifier.visitButton.website')}
                            </Font.FuturaHeavy>
                        </Link>
                    </div>
                )}
                {uriResults && (
                    <div className={`col-12 ${styles.button_container}`}>
                        <Link href={`/utmb-index/races/${uriResults}`} className={styles.button}>
                            <Icon variant={IconsEnum.RACE} />
                            <Font.FuturaHeavy mobile="14" className={styles.button_label}>
                                {t('qualifier.visitButton.race')}
                            </Font.FuturaHeavy>
                        </Link>
                    </div>
                )}
            </div>
        </>
    );
};

export default QualifiersMobileContent;
